import React from 'react'
import { ILogStats } from '../scripts/calculateStats'
import '../styles/requestsByHourChart.css'
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer
} from 'recharts'

interface RequestsByHourChartProps {
    stats: ILogStats
}

function RequestsByHourChart({ stats }: RequestsByHourChartProps) {
    return (
        <div className='requests_by_hour_container'>
            <div className='chart_header'>
                <h3 className='chart_title'>Requisições por Hora</h3>
                <p className='chart_description'>Distribuição de requisições ao longo do dia</p>
            </div>
            <div className='chart_wrapper'>
                <ResponsiveContainer width="100%" height={400}>
                    <BarChart
                        data={stats.requestsByHour}
                        margin={{ top: 20, right: 30, left: 0, bottom: 20 }}
                    >
                        <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
                        <XAxis
                            dataKey="hour"
                            stroke="#666"
                            style={{ fontSize: '0.85em' }}
                        />
                        <YAxis
                            stroke="#666"
                            style={{ fontSize: '0.85em' }}
                        />
                        <Tooltip
                            contentStyle={{
                                backgroundColor: '#ffffff',
                                border: '1px solid #e0e0e0',
                                borderRadius: '6px',
                                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
                            }}
                            labelStyle={{ color: '#333' }}
                            formatter={(value: number) => [`${value} requisições`, 'Total']}
                            cursor={{ fill: 'rgba(3, 96, 170, 0.1)' }}
                        />
                        <Legend
                            wrapperStyle={{ paddingTop: '20px' }}
                            iconType="square"
                        />
                        <Bar
                            dataKey="count"
                            fill="#0360aa"
                            name="Requisições"
                            radius={[8, 8, 0, 0]}
                        />
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    )
}

export default RequestsByHourChart
